import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Money = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M21.876 15.236c.207-4.075.168-6.113-.216-10.188-.266-.099-.394-.148-.65-.247-2.087-.797-4.233-1.023-6.28-.57-.65.147-.985.226-1.645.383-.098.03-.147.05-.246.08-2.284.708-4.784.757-7.028.167a2.233 2.233 0 0 1-.247-.06c-.255 4.233-.285 6.34-.147 10.573.098.03.147.05.256.089 2.362.787 4.843.846 7.176.098.099-.03.148-.05.246-.079.68-.167 1.014-.256 1.693-.423a13.074 13.074 0 0 1 6.439.03l.65.147Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M10.339 11.535c0 .295.217.521.482.521.276 0 .483-.226.483-.521V10.5h.777c.375.512.571.768.945 1.29a.555.555 0 0 0 .483.265.467.467 0 0 0 .463-.482c0-.157-.06-.266-.158-.403a29.496 29.496 0 0 0-.68-.877c.532-.236.877-.689.877-1.437v-.01c0-.443-.138-.817-.384-1.083-.286-.315-.719-.482-1.27-.482h-1.516c-.266 0-.482.236-.482.522-.01 1.486-.02 2.235-.02 3.73Zm.975-1.96V8.218h.954c.473 0 .758.237.758.68v.01c0 .403-.265.669-.738.669h-.974ZM14.789 12.618c0 .285.206.512.472.512s.482-.237.482-.512v-1.073c.227.285.542.531 1.054.531.797 0 1.545-.65 1.526-1.83v-.01c-.01-1.182-.778-1.851-1.566-1.861-.492-.01-.807.236-1.033.561v-.05a.512.512 0 0 0-.483-.52c-.265 0-.472.226-.472.501.03 1.506.03 2.254.02 3.75Zm1.771-1.398c-.443 0-.817-.394-.826-.994v-.01c0-.6.364-.994.807-.985.443.01.827.404.837.995v.01c0 .6-.375.984-.818.984Z"
      fill="currentColor"
    />
    <Path
      d="M2.188 7.026c-.266 4.066-.256 6.104.069 10.17.994.826 4.016 2.598 8.407 2.175C13.597 18.957 15.5 18 18 18"
      fill="transparent"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M21.102 17c.61 0 1.101.502 1.101 1.111a1.1 1.1 0 0 1-1.101 1.102c-.61 0-1.112-.492-1.102-1.102 0-.61.492-1.111 1.102-1.111Z"
      fill="currentColor"
    />
  </Icon>
);

export default Money;
